import * as Actions from 'store/actions/app/territorial_division.actions'

const initialState = {
  loading_departments: false,
  departments: [],

  loading_provinces_by_department: false,
  provinces_by_department: [],

  loading_districts_by_province: false,
  districts_by_province: [],
}

const territorialDivisionReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_DEPARTMENTS: {
      return {
        ...state,
        loading_departments: action.payload.loading,
        departments: action.payload.data ?? state.departments,
      }
    }
    case Actions.GET_PROVINCES_BY_DEPARTMENT_ID: {
      return {
        ...state,
        loading_provinces_by_department: action.payload.loading,
        provinces_by_department: action.payload.data ?? state.provinces_by_department,
      }
    }
    case Actions.GET_DISTRICTS_BY_PROVINCE_ID: {
      return {
        ...state,
        loading_districts_by_province: action.payload.loading,
        districts_by_province: action.payload.data ?? state.districts_by_province,
      }
    }
    default: {
      return state
    }
  }
}

export default territorialDivisionReducer
